import { useState } from 'react';
import { Link } from 'react-router-dom';
import '../HeaderNav/HeaderNav.scss';
import Logo from '../Logo';



const HeaderNav = (props) =>{
   
    const [isOpen, setIsOpen] = useState(false);

  const handleBurgerIconClick = () => {
    setIsOpen(!isOpen);
  };


return (
    <>
        <div className='header__nav-wrapper'>
            <Logo/>
            <nav className="nav">
                <Link className="nav__item" to="/home">Home</Link>
                {/* <Link to="/blog" className="nav__item" >Blog</Link> */}
                <Link className="nav__item" to="/vacancies">Careers</Link>
                <Link className="nav__item" to="/contact" >Contact us</Link>
                <div 
                     className={`nav__burger-icon ${isOpen ? 'open' : ''}`}
                     onClick={handleBurgerIconClick} >
                    <div className='nav__burger-icon--span'></div>
                    <div className='nav__burger-icon--span'></div>
                    <div className='nav__burger-icon--span'></div>
                </div>
            </nav>
        </div>
        <div  className={`nav__burger-menu ${isOpen ? 'open' : ''}`}>
                <Link className="nav__burger-menu--item" to="/home">Home</Link>
                {/* <a className="nav__burger-menu--item" href="#">Blog</a> */}
                <Link className="nav__burger-menu--item" to="/vacancies">Vacancies</Link>
                <a className="nav__burger-menu--item" href="#">Contact us</a>
        </div>
    </>
)
}

export default HeaderNav;